<template>
  <div class="filter">
    <el-select v-model="form.disciplineValue" placeholder="Select">
        <el-option
        v-for="item in utilityData.disciplineOptions"
        :key="item.value"
        :label="item.name"
        :value="item.id">
        </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
    data() {
        return {
            form:{
                disciplineValue:''
            },
            utilityData:{
                disciplineOptions:[]
            }
        }
    },
    mounted() {
        this.axios.get('/api/disciplines')
        .then(res=>{
            this.utilityData.disciplineOptions = res.data.disciplines
        })
    },
   
}
</script>

<style lang="scss">
    .filter{
        padding: 20px;
        border-radius: 20px 0 0 20px;
        position: fixed;
        right: 0;
        top:0;
        height: 100%;
        width: 300px;
        border: 1px solid red;
        background-color: $basic-white;
        z-index: 25;
        display: grid;
        grid-template-rows: repeat(auto-fill, minmax(50px, 1fr));
        row-gap: 20px;
        align-items: center;
    }
</style>